import { StyleSheet, View } from 'react-native'
import React, { useEffect } from 'react'
import Animated, { Easing, runOnJS, useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated'
import { displayFont } from '../../fonts'

const Preloader = ({ onDone }) => {
  const cover = useSharedValue(1)
  const sweep = useSharedValue(-40)
  const logo = useSharedValue(0.86)

  useEffect(() => {
    logo.value = withRepeat(withTiming(1, { duration: 700, easing: Easing.inOut(Easing.cubic) }), -1, true)
    sweep.value = withRepeat(withTiming(140, { duration: 1100, easing: Easing.inOut(Easing.cubic) }), -1, false)
    const timer = setTimeout(() => {
      cover.value = withTiming(0, { duration: 480, easing: Easing.out(Easing.cubic) }, (finished) => {
        if (finished) runOnJS(onDone)()
      })
    }, 1700)
    return () => clearTimeout(timer)
  }, [])

  const coverStyle = useAnimatedStyle(() => ({
    opacity: cover.value,
  }))

  const logoStyle = useAnimatedStyle(() => ({
    transform: [{ scale: logo.value }],
  }))

  const sweepStyle = useAnimatedStyle(() => ({
    left: `${sweep.value}%`,
  }))

  return (
    <Animated.View accessibilityRole="progressbar" accessibilityLabel="Loading iVYOOO" pointerEvents="auto" style={[styles.cover, coverStyle]}>
      <Animated.Image accessibilityLabel="iVYOOO" resizeMode="contain" source={{ uri: 'https://ivyooo.com/assets/images/ivyooo.png' }} style={[styles.logo, logoStyle]} />
      <View style={styles.track}>
        <Animated.View style={[styles.sweep, sweepStyle]} />
      </View>
      <Animated.Text style={styles.word}>iVYOOO</Animated.Text>
    </Animated.View>
  )
}

export default Preloader

const styles = StyleSheet.create({
  cover: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: '#050505',
    zIndex: 50,
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    width: 72,
    height: 72,
  },
  track: {
    marginTop: 28,
    width: 160,
    height: 2,
    backgroundColor: 'rgba(255,255,255,0.16)',
    overflow: 'hidden',
  },
  sweep: {
    position: 'absolute',
    top: 0,
    width: 54,
    height: 2,
    backgroundColor: '#E61E25',
  },
  word: {
    marginTop: 16,
    color: '#FFFFFF',
    fontFamily: displayFont,
    fontSize: 13,
    letterSpacing: 6,
    fontWeight: '600',
  },
})
